// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x5a1","name":"styles_name__3nniM","phone":"styles_phone__K4Yls"};